/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import {provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {importProvidersFrom, inject, provideAppInitializer} from "@angular/core";
import {Location} from "@angular/common";
import {MenuService} from "./app/models/menu.service";
import {Menu} from "./app/models/menu";
import {map} from "rxjs/operators";
import {IonicStorageModule} from "@ionic/storage-angular";
import {localeInterceptor} from "./app/core/interceptor/locale.interceptor";

export let MENU_MODEL: Menu;

bootstrapApplication(AppComponent, {
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideIonicAngular(),
    provideHttpClient(withInterceptors([localeInterceptor]), withInterceptorsFromDi()),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAppInitializer(() => {
      const location = inject(Location);
      const uuid = location.path(false).split('?')[0].split('/')[1];
      return inject(MenuService).find(uuid).pipe(map(menu => MENU_MODEL = menu));
    }),
    importProvidersFrom(IonicStorageModule.forRoot())
  ]
});
